import React, { useContext } from 'react';
import { arrayOf, func, object } from 'prop-types';
import { connect } from 'react-redux';
import GigCardListings from '@fiverr-private/gig_listings/src/entries/GigCardListings';
import { getContext } from '@fiverr-private/fiverr_context';
import { pageContext } from '../../../../shared/gigListings/constants';
import { setAllCollections } from '../../../../store/collections/actions';
import { loadMoreGigs } from '../../../../store/gigsView/actions';
import useGigListing from '../../../../../../shared/hooks/useGigListing';
import ShowMore from '../../../../../../shared/components/ShowMore';
import LazyPersonalizedSectionFetcher from '../../../../../../shared/components/LazyPersonalizedSectionFetcher';
import { PAGE_NAME } from '../../../../shared/constants';
import SharedContext from '../../../../../../shared/context';
import { LAZY_LOAD_OFFSET } from './constants';

const Gigs = ({ gigsView, collections, setAllCollections, loadMoreGigs, currentCollection = {} }) => {
    const { userId } = getContext();
    const { rollouts } = useContext(SharedContext);
    const isLoggedIn = !!userId;
    const { contextEnrichment, collectProps } = useGigListing({
        pageContext,
        collections,
        onUpdateCollections: setAllCollections,
    });

    const recommendationsParams = {
        collection: {
            id: currentCollection.id,
            gig_ids: gigsView.gigs.map((_) => _.gig_id).join(','),
        },
    };

    return (
        <>
            <GigCardListings
                gigs={gigsView.gigs}
                lazyLoadOffset={LAZY_LOAD_OFFSET}
                markUnavailable
                collectProps={collectProps}
                rollouts={rollouts}
                {...contextEnrichment}
            />
            <ShowMore hasMorePages={gigsView.hasMorePages} loadMore={loadMoreGigs} />
            {isLoggedIn && (
                <LazyPersonalizedSectionFetcher
                    className="recommendations"
                    sectionName="carousels"
                    recommendationsParams={recommendationsParams}
                    collections={collections}
                    onUpdateCollections={setAllCollections}
                    pageName={PAGE_NAME}
                />
            )}
        </>
    );
};

Gigs.propTypes = {
    gigsView: object,
    collections: arrayOf(object),
    setAllCollections: func,
    loadMoreGigs: func,
    currentCollection: object,
};

const mapDispatchToProps = {
    setAllCollections,
    loadMoreGigs,
};

const mapStateToProps = ({ gigsView, collections, collection: currentCollection }) => ({
    gigsView,
    collections,
    currentCollection,
});

export { Gigs };
export default connect(mapStateToProps, mapDispatchToProps)(Gigs);
